import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './DashboardPage.css';
import './Definitions.css';
import AddBranchForm from '../../components/AddBranchForm/AddBranchForm';
import AddDepartmentForm from '../../components/AddDepartmentForm/AddDepartmentForm';
import { fetchBranches } from '../../store/slices/branchSlice';

const TABS = [
  { id: 'branch', label: 'Şube' },
  { id: 'department', label: 'Departman' },
];

export default function Definitions() {
  const [activeTab, setActiveTab] = useState('branch');
  const dispatch = useDispatch();
  const { branches, isLoading: branchesLoading } = useSelector((state) => state.branch);

  useEffect(() => {
    dispatch(fetchBranches());
  }, [dispatch]);

  return (
    <div className="dashboard-page">
      <h2>Tanımlamalar</h2>

      <div className="definitions-tabs">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`definitions-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="definitions-content">
        {activeTab === 'branch' && <AddBranchForm />}
        {activeTab === 'department' && (
          <AddDepartmentForm branches={branches} isLoading={branchesLoading} />
        )}
      </div>
    </div>
  );
}
